import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WarningGroup } from '../../models/error-warning.model';

@Component({
  selector: 'app-default-warnings',
  imports: [TranslateModule],
  templateUrl: './default-warnings.component.html',
  styleUrls: ['./default-warnings.component.scss']
})
export class DefaultWarningsComponent {
  @Input() warnings: WarningGroup[];
}
